import { useEffect } from 'react';
import { trackEvent } from '../components/Analytics';

/**
 * Tracks outbound clicks and CTA interactions
 * Automatically detects mailto:, tel:, and external links
 */
export function useClickTracking(pageName) {
  useEffect(() => {
    const handleClick = (e) => {
      const target = e.target.closest('a');
      if (!target) return;

      const href = target.href || '';
      const isExternal = href.startsWith('http') && !href.includes(window.location.hostname);
      const isMailto = href.startsWith('mailto:');
      const isTel = href.startsWith('tel:');
      const isCta = target.classList.contains('cta-button') || 
                    target.textContent.toLowerCase().includes('start a conversation') ||
                    target.textContent.toLowerCase().includes('schedule') ||
                    target.textContent.toLowerCase().includes('contact') ||
                    target.textContent.toLowerCase().includes('inquire');

      if (isExternal) {
        trackEvent('outbound_click', {
          event_category: 'engagement',
          event_label: href,
          link_url: href,
          link_domain: new URL(href).hostname,
          page_name: pageName,
        });
      }

      if (isMailto) {
        trackEvent('contact_click', {
          event_category: 'conversion',
          event_label: 'email_click',
          contact_method: 'email',
          email_address: href.replace('mailto:', ''),
          page_name: pageName,
        });
      }

      if (isTel) {
        trackEvent('contact_click', {
          event_category: 'conversion',
          event_label: 'phone_click',
          contact_method: 'phone',
          page_name: pageName,
        });
      }

      if (isCta && !isExternal && !isMailto && !isTel) {
        trackEvent('cta_click', {
          event_category: 'conversion',
          event_label: target.textContent.trim(),
          cta_text: target.textContent.trim(),
          destination_url: href,
          page_name: pageName,
        });
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [pageName]);
}
